// extracted by mini-css-extract-plugin
export default {"wrapper":"Layout_wrapper__H2bdg","content":"Layout_content__OMJT7","data":"Layout_data__EsjcO","noPadding":"Layout_noPadding__r57Km"};